// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { SiteV3ClientGeneratedExternalIdType } from './siteV3ClientGeneratedExternalIdType.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class SiteV3ClientGeneratedExternalIdUpsearchModel {
    'id'?: number | null;
    'externalIdType'?: SiteV3ClientGeneratedExternalIdType;
    'externalId': string;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof SiteV3ClientGeneratedExternalIdUpsearchModel>> = [
        {
            "name":     "id",
            "baseName": "id",
            "type":     "number"
        },
        {
            "name":     "externalIdType",
            "baseName": "externalIdType",
            "type":     "SiteV3ClientGeneratedExternalIdType"
        },
        {
            "name":     "externalId",
            "baseName": "externalId",
            "type":     "string"
        },
    ];

    static getAttributeTypeMap() {
        return SiteV3ClientGeneratedExternalIdUpsearchModel.attributeTypeMap;
    }
}
